// @flow strict

// "Peter Huang" > "peter-huang"
const slugifyString = (str: string) => {
  const a = 'àáäâãåăæçèéëêǵḧìíïîḿńǹñòóöôœṕŕßśșțùúüûǘẃẍÿź·/_,:;'
  const b = 'aaaaaaaaceeeeghiiiimnnnoooooprssstuuuuuwxyz------'
  const p = new RegExp(a.split('').join('|'), 'g')
  if (!str) {
    console.warn('No string provided to slugify')
    return ''
  }
  return str
    .toString()
    .toLowerCase()
    .replace(/\s+/g, '-') // Replace spaces with -
    .replace(p, c => b.charAt(a.indexOf(c))) // Replace special characters
    .replace(/&/g, '-and-') // Replace & with 'and'
    .replace(/[^\w-]+/g, '') // Remove all non-word characters
    .replace(/--+/g, '-') // Replace multiple - with single -
    .replace(/^-+/, '') // Trim - from start of text
    .replace(/-+$/, '') // Trim - from end of text
}

// "Peter Huang" > "Peter"
const returnFirstWord = (str: string) => str && str.split(' ')[0]

// "Fri Jun 07 2019 14:31:36 GMT+0100 (British Summer Time)" > "2019/06/07"
const backSlashDateString = (isoDateString: string) => {
  const prependZeroIfSingleDigit = num =>
    num.toString().length === 1 ? '0' + num : num

  const dateObject = new Date(isoDateString)
  const monthNumber = dateObject.getMonth() + 1
  const monthNumberString = prependZeroIfSingleDigit(monthNumber)
  const dateNumber = dateObject.getDate()
  const dateNumberString = prependZeroIfSingleDigit(dateNumber)
  const year = dateObject.getFullYear()

  return `${year}/${monthNumberString}/${dateNumberString}`
}

// Give it a domain agnostic url or an insecure (http) url, and it'll turn it into an https url
const prefixHttpsToUrl = (url: string): string => {
  if (url) {
    if (url.indexOf('http://') === 0) {
      return `https://${url.substring(7)}`
    } else if (url.indexOf('//') === 0) {
      return `https:${url}`
    }
  }
  return url
}

export { slugifyString, returnFirstWord, backSlashDateString, prefixHttpsToUrl }
